import { fetch as fetchPolyfill } from 'whatwg-fetch';
import 'consumerweb-shim';

export const polyfillFetch = (url, options) => {
  return fetchPolyfill(url, options);
};
